export const scrollListToSelectedOption = (list, options) => {
    var _a, _b;
    const option = options.find((node) => (node === null || node === void 0 ? void 0 : node.getAttribute('aria-selected')) === 'true') ||
        options[0];
    // Focus selected or first option
    if (!option) {
        return;
    }
    (_a = option.focus) === null || _a === void 0 ? void 0 : _a.call(option, { preventScroll: true });
    if (list) {
        // How are these reassignment violations?
        /* eslint-disable no-param-reassign */
        // Disable overflow while to hide the scrollbar while scrolling to the element
        list.style.overflowY = 'hidden';
        list.scrollTop =
            option.offsetTop - option.clientHeight * 2 - (((_b = options[0]) === null || _b === void 0 ? void 0 : _b.offsetTop) || 0);
        setTimeout(() => {
            if (list) {
                list.style.overflowY = 'auto';
            }
        }, 400);
        /* eslint-enable no-param-reassign */
    }
};
//# sourceMappingURL=scrollListToSelectedOption.js.map